// Module
var code = "<section class=\"live-review-help-wrapper\" role=\"alert\" aria-live><p translate=\"activity-editor-new_live-review-help\"></p></section>";
// Exports
module.exports = code;